import React from 'react'
import useUserDiscussions from '../../../hooks/use-user-discussions'
import DiscussionLarge from './discussion-large'
import DiscussionSmall from './discussion-small'
import { first } from 'lodash'
import useClientLocation from '../../../hooks/use-client-location'
import hooks from '../../../hooks'
import { Spinner } from 'react-bootstrap'
import LoadMoreButton from './load-more-button'

const DiscussionsList = () => {
    const [scrollPos, setScrollPos] = React.useState(0)
    const [scrollHeight, setScrollHeight] = React.useState(-1)
    const { toLocation, endpoints, params } = useClientLocation()
    const { userDiscussions, isLoading, canFetchMore, fetchMore } = useUserDiscussions()
    const { isSm, isXs } = hooks.useViewport()
    const { discussionId } = params

    const isSmall = isSm || isXs

    const selectDiscussion = React.useCallback(discussionId => {
        toLocation(`${endpoints.DISCUSSIONS}/${discussionId}`)
    }, [toLocation, endpoints])

    React.useEffect(() => {
        if(!discussionId && !isLoading && userDiscussions.length) {
            selectDiscussion(first(userDiscussions).id)
        }
    }, [discussionId, userDiscussions, selectDiscussion])

    React.useEffect(() => {
        if (canFetchMore && scrollPos === scrollHeight) {
            fetchMore()
        }
    }, [scrollPos, scrollHeight, canFetchMore])

    const handleScroll = (e) => {
        setScrollHeight(e.target.clientHeight)
        setScrollPos(e.target.scrollHeight - e.target.scrollTop)
        
    }

    const renderDiscussion = (discussion) => {
        const Discussion = isSmall ? DiscussionSmall : DiscussionLarge
        return (
            <Discussion
                onClick={() => selectDiscussion(discussion.id)}
                key={discussion.id}
                discussion={discussion}
                active={discussionId === discussion.id}
            />
        )
    }

    const renderMoreButton = () => {
        if (!canFetchMore && !isLoading) {
            return null
        }
        return (
            <LoadMoreButton isBusy={isLoading} onClick={fetchMore} />
        )
    }

    //onScroll={handleScroll}
    return (
        <div style={{
            minWidth: isSmall ? '100px' : '350px',
            width: isSmall ? '100px' : '350px',
            borderRight: '1px solid rgb(225, 225, 225)',
            height: 'calc(100%)'
        }}>
            <div
                style={{
                    height: 'calc(100%)',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                
            >
                {userDiscussions.map(renderDiscussion)}
                {renderMoreButton()}
            </div>
        </div>
    )
}

export default DiscussionsList
